export default __webpack_public_path__ + "static/media/yotta21-light-mode.e9fd99cf.png";